<template>
    <b-row>
        <b-col cols="12" class="h4 mb-3">
            {{ $t('gracias.fecha') }} {{ sesion_fecha }}
        </b-col>
        <b-col cols="12">
            <div class="lightgray-content p-2 small-font mb-2 pb-2 border-bottom d-flex" :key="index">
                <div class="d-flex w-100 justify-content-between align-items-center container-fluid position-relative p-1">
                    <div>
                        <strong class="mb-2 red text-uppercase">
                            {{ manager.termino_entrada }}
                            {{ index + 1 }}
                        </strong>
                        <div>
                            <span class="h3 mb-3 text-italicy">
                                {{ entrada.asiento?.zona?.nombre }}
                            </span>
                        </div>
                        <template v-if="entrada.asiento?.fila && entrada.asiento?.numero">
                            <div>
                                <label class="mb-1 text-bold">Fila:</label>
                                {{ entrada.asiento.fila }}
                            </div>
                            <div>
                                <label class="mb-1 text-bold">Butaca:</label>
                                {{ entrada.asiento.numero }}
                            </div>
                        </template>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <div class="text-center">
                            <label>{{ $t("gracias.precio") }}</label><br />
                            <span class="h2" v-if="!entrada.descuento_porcentaje">
                                {{ entrada.importe | formatear_precio }}
                            </span>
                            <template v-else>
                                <div class="d-flex align-items-center">
                                    <span class="h2">
                                        {{ entrada.importe_con_descuento | formatear_precio }}
                                    </span>
                                    <span class="h4 ml-1">
                                        (<del>
                                            {{ entrada.importe | formatear_precio }}
                                        </del>)
                                    </span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: {
            entrada: {
                required: true,
                type: Object
            },
            sesion_fecha: {
                required: true,
                type: String
            },
            index: {
                required: true,
                type: Number
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        }
    }
</script>